import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import clsx from 'clsx';
import { Snackbar, SnackbarContent, IconButton, Typography } from '@material-ui/core';
import { darken, makeStyles } from '@material-ui/core/styles';
import Close from '@material-ui/icons/Close';
import NotificationsActiveTwoTone from '@material-ui/icons/NotificationsActiveTwoTone';
import { CheckCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon, InfoIcon } from '../Icon';
import { ALERT_VARIANTS } from '../../design/AlertVariants';
const getAlertStyles = (variant, palette, themeName) => {
    if (themeName === 'liquidity') {
        switch (variant) {
            case 'success':
                return {
                    backgroundColor: palette.success.main,
                    color: palette.success.contrastText,
                    '&$outlined': {
                        backgroundColor: palette.success.lightShade190p,
                        borderColor: palette.success.darkShade160p,
                        color: palette.success.darkShade160p,
                    },
                };
            case 'warning':
                return {
                    backgroundColor: palette.warning.main,
                    color: palette.warning.contrastText,
                    '&$outlined': {
                        backgroundColor: palette.warning.lightShade190p,
                        borderColor: palette.warning.darkShade160p,
                        color: palette.warning.darkShade160p,
                    },
                };
            case 'error':
                return {
                    backgroundColor: palette.error.main,
                    color: darken(palette.error.main, 0.83),
                    '&$outlined': {
                        backgroundColor: palette.error.lightShade190p,
                        borderColor: palette.error.darkShade160p,
                        color: palette.error.darkShade160p,
                    },
                };
            case 'info':
                return {
                    backgroundColor: palette.info.main,
                    color: palette.info.contrastText,
                    '&$outlined': {
                        backgroundColor: palette.info.lightShade190p,
                        borderColor: palette.info.darkShade160p,
                        color: palette.info.darkShade160p,
                    },
                };
        }
    }
    switch (variant) {
        case 'success':
            return {
                backgroundColor: palette.success.main,
                '&$outlined': {
                    backgroundColor: palette.success.lightShade190p,
                    borderColor: palette.success.main,
                    color: palette.success.contrastText,
                },
            };
        case 'warning':
            return {
                backgroundColor: palette.warning.main,
                color: palette.warning.contrastText,
                '&$outlined': {
                    backgroundColor: palette.warning.lightShade190p,
                    borderColor: palette.warning.main,
                },
            };
        case 'error':
            return {
                backgroundColor: palette.error.main,
                color: palette.text.secondary,
                '&$outlined': {
                    backgroundColor: palette.error.lightShade190p,
                    borderColor: palette.error.main,
                    color: palette.error.contrastText,
                },
            };
        case 'info':
            return {
                backgroundColor: palette.info.main,
                color: palette.info.contrastText,
                '&$outlined': {
                    backgroundColor: palette.info.light,
                    borderColor: palette.info.main,
                },
            };
    }
    return {};
};
const useStyles = makeStyles(({ spacing, palette, name }) => ({
    outlined: {
        border: '1px solid',
    },
    [ALERT_VARIANTS.success]: getAlertStyles('success', palette, name),
    [ALERT_VARIANTS.warning]: getAlertStyles('warning', palette, name),
    [ALERT_VARIANTS.error]: getAlertStyles('error', palette, name),
    [ALERT_VARIANTS.info]: getAlertStyles('info', palette, name),
    icon: {
        fontSize: 20,
        marginRight: spacing(2.5),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
        color: 'inherit',
        fontWeight: 700,
    },
}));
export const Alert = (_a) => {
    var { variant, outlined, children, onClose, testId, closeButtonTestId, icon = variant, anchorOrigin = {
        vertical: 'top',
        horizontal: 'center',
    } } = _a, other = __rest(_a, ["variant", "outlined", "children", "onClose", "testId", "closeButtonTestId", "icon", "anchorOrigin"]);
    const classes = useStyles();
    const displayIcon = React.useMemo(() => {
        if (typeof icon !== 'string') {
            return icon;
        }
        if (icon === 'success') {
            return _jsx(CheckCircleIcon, { className: classes.icon }, void 0);
        }
        if (icon === 'warning') {
            return _jsx(ExclamationTriangleIcon, { className: classes.icon }, void 0);
        }
        if (icon === 'error') {
            return _jsx(ExclamationCircleIcon, { className: classes.icon }, void 0);
        }
        if (icon === 'info') {
            return _jsx(InfoIcon, { className: classes.icon }, void 0);
        }
        return _jsx(NotificationsActiveTwoTone, { className: classes.icon }, void 0);
    }, [icon, variant]);
    return (_jsx(Snackbar, Object.assign({ anchorOrigin: anchorOrigin, "data-testid": testId }, other, { children: _jsx(SnackbarContent, { className: clsx(classes[variant], outlined && classes.outlined), "aria-describedby": "client-alert", message: _jsxs(Typography, Object.assign({ id: "client-alert", className: classes.message }, { children: [displayIcon,
                    children] }), void 0), action: [
                _jsx(IconButton, Object.assign({ "aria-label": "close", color: "inherit", onClick: onClose, "data-testid": closeButtonTestId }, { children: _jsx(Close, {}, void 0) }), "close"),
            ] }, void 0) }), void 0));
};
//# sourceMappingURL=Alert.js.map